import {
  PACKS_REQUEST, PACKS_RESPONSE, PACKS_FAILURE,
} from '../../actions/billing/topup';

const initialState = {
  packs: [],
  packsLoading: false,
  packsError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PACKS_REQUEST:
      return { ...state, packsLoading: true, packsError: null };
    case PACKS_RESPONSE:
      return { ...state, packsLoading: false, packs: action.payload || [] };
    case PACKS_FAILURE:
      return { ...state, packsLoading: false, packsError: action.payload };
    default:
      return state;
  }
};
